var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', [_c('v-card', {
    staticClass: "grey-ef",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-24 pa-md-30"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h4', {
    staticClass: "tit tit--xs primary--text"
  }, [_vm._v("* 위탁 신청 전에 읽어주세요")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("1. 심의 항목 : 작품성, 작품상태, 판매가능성, 작품가치, 판매대상 범위와의 부합성 등 다양한 측면을 고려하여 서면심의를 진행합니다")]), _c('p', [_vm._v("2. 심의 기간 : 접수일로부터 7일 이내 심의를 완료합니다")]), _c('p', [_vm._v("3. 심의 결과 안내 : 위탁신청 접수 내용을 토대로 심의 후, 위탁 가능 여부를 위탁자에게 개별 안내해 드립니다")])])])], 1)], 1), _c('div', {
    staticClass: "mt-30 mt-md-40"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('myinfo-modify-row', {
    attrs: {
      "label": "이름"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "name", $$v);
      },
      expression: "form.meta.name"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "연락처"
    }
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', {
    attrs: {
      "items": ['010', '011', '016', '017', '019'],
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "phone1", $$v);
      },
      expression: "form.meta.phone1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.form.meta.phone2 = _vm.form.meta.phone2.replace(/[^0-9]/g, '');
      }
    },
    model: {
      value: _vm.form.meta.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "phone2", $$v);
      },
      expression: "form.meta.phone2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.form.meta.phone2 = _vm.form.meta.phone2.replace(/[^0-9]/g, '');
      }
    },
    model: {
      value: _vm.form.meta.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "phone3", $$v);
      },
      expression: "form.meta.phone3"
    }
  })], 1)], 1)], 1)]), _c('myinfo-modify-row', {
    attrs: {
      "label": "이메일"
    }
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email1",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.email1,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email1", $$v);
      },
      expression: "form.meta.email1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email2",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.email2,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email2", $$v);
      },
      expression: "form.meta.email2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-select', {
    staticClass: "w-100 mw-sm-160px",
    attrs: {
      "items": [{
        text: '직접입력',
        value: null
      }, 'naver.com', 'daum.com', 'google.com'],
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        _vm.form.meta.email2 = _vm.form.meta.email3;
      }
    },
    model: {
      value: _vm.form.meta.email3,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email3", $$v);
      },
      expression: "form.meta.email3"
    }
  })], 1)], 1)], 1)])], 1)]), _c('div', {
    staticClass: "mt-30 mt-md-40"
  }, [_vm._m(1), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('myinfo-modify-row', {
    attrs: {
      "label": "작가명"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.author,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "author", $$v);
      },
      expression: "form.meta.author"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "작품명"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "subject", $$v);
      },
      expression: "form.meta.subject"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "작품의 재료"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.material,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "material", $$v);
      },
      expression: "form.meta.material"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "작품의 크기"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.dimension,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "dimension", $$v);
      },
      expression: "form.meta.dimension"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "Edition"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.edition,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "edition", $$v);
      },
      expression: "form.meta.edition"
    }
  }), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("* 작품이 판화인 경우에 기입해 주세요")])])], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "제작년도(추정)"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.year,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "year", $$v);
      },
      expression: "form.meta.year"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "작품설명"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "content", $$v);
      },
      expression: "form.meta.content"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "기타"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.etc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "etc", $$v);
      },
      expression: "form.meta.etc"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "작품 이미지"
    }
  }, [_c('images-input', {
    attrs: {
      "cols": "2"
    },
    model: {
      value: _vm.form.files,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "files", $$v);
      },
      expression: "form.files"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "구입가(KRW)"
    }
  }, [_c('v-currency-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.price_bought,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "price_bought", $$v);
      },
      expression: "form.meta.price_bought"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "label": "희망가(KRW)"
    }
  }, [_c('v-currency-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.price_asking,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "price_asking", $$v);
      },
      expression: "form.meta.price_asking"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "mt-30 mt-md-50"
  }, [_c('div', {
    staticClass: "v-btn--group v-btn--group--large"
  }, [_c('v-btn', {
    staticClass: "w-100 mw-220px",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "grey-cb"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("취소")])]), _c('v-btn', {
    staticClass: "w-100 mw-220px",
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('save');
      }
    }
  }, [_vm._v("위탁신청")])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-10"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("위탁 신청인 정보")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-10"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("위탁 작품 정보")])]);
}]

export { render, staticRenderFns }